import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Aside from "../aside";

import { toggleSidebar } from "../../../../store/actions/layout";
import { getUserRequest } from "../../../../services/userService";
import { showErrorMessage } from "../../../../services/httpService";

import config from "../../../../services/config.json";
const { imageIP } = config;

const Request = () => {
   const dispatch = useDispatch();
   const { reqId } = useParams();

   const { isSidebarOpened } = useSelector((state) => state.layout);
   const [request, setRequest] = useState({
      theDate: '',
      status: '',
      details: {
         storeName: '',
         managerName: '',
         storeType: '',
         cooperationType: '',
         storePhoneNumber: '',
         storePostalCode: '',
         aboutStore: '',
         requestText: '',
         fileList: null
      }
   });

   useEffect(() => {
      const getData = async () => {
         const res = await getUserRequest(reqId);
         if (res.error) {
            return showErrorMessage(res);
         } else {
            setRequest(res.data);
         }
      };
      getData();
      window.scrollTo(0, 0);
   }, []);

   return (
      <section className="container">
         <div className="container__row">
            <Aside />
            <main
               className="main__container"
               onClick={() => isSidebarOpened && dispatch(toggleSidebar())}
            >
               <div className="orders-details">
                  <div className="cards__header cards__header--orders-details">
                     <Link to="/requests" className="back">
                        <img src="/img/right-arrow-3558_prev_ui.png" alt="back" />
                     </Link>
                     <div>
                        <span>تاریخ ثبت</span>
                        <span>{request.theDate}</span>
                     </div>
                     <span className="cards__situation">{request.status}</span>
                  </div>

                  <section className="orders-details__info" style={{ padding: '1rem 3rem', justifyContent: 'space-between' }}>
                     <div className="orders-details__list">
                        <div className="orders-details__row">
                           <span className="orders-details__title">نام فروشگاه :</span>
                           <span className="orders-details__item">
                              {request.details.storeName}</span>
                        </div>
                        <div className="orders-details__row">
                           <span className="orders-details__title">نوع فروشگاه :</span>
                           <span className="orders-details__item">
                              {request.details.storeType}
                           </span>
                        </div>
                        <div className="orders-details__row">
                           <span className="orders-details__title">تلفن فروشگاه :</span>
                           <span className="orders-details__item">
                              {request.details.storePhoneNumber}
                           </span>
                        </div>
                     </div>

                     <div className="orders-details__list">
                        <div className="orders-details__row">
                           <span className="orders-details__title">نام مدیر :</span>
                           <span className="orders-details__item">
                              {request.details.managerName}
                           </span>
                        </div>
                        <div className="orders-details__row">
                           <span className="orders-details__title">نوع همکاری :</span>
                           <span className="orders-details__item">
                              {request.details.cooperationType}
                           </span>
                        </div>
                        <div className="orders-details__row">
                           <span className="orders-details__title">کدپستی :</span>
                           <span className="orders-details__item">
                              {request.details.storePostalCode}
                           </span>
                        </div>
                     </div>

                     <div className="orders-details__list" style={{ flex: '0 0 20%' }}>
                        <img
                           style={{ width: '100%', height: 'auto' }}
                           src={`${imageIP}${request.details?.fileList && request.details.fileList[request.details.fileList?.length - 1]?.fileUrl}`}
                        />
                     </div>
                  </section>


                  <div
                     className="orders-details__list"
                     style={{ padding: '1rem 3rem', textAlign: 'justify' }}
                  >
                     <div className="orders-details__row">
                        <span className="orders-details__title">درباره فروشگاه :</span>
                        <span className="orders-details__item">
                           {request.details.aboutStore || '-'}
                        </span>
                     </div>
                  </div>

                  <div
                     className="orders-details__list"
                     style={{ padding: '1rem 3rem', textAlign: 'justify' }}
                  >
                     <div className="orders-details__row">
                        <span className="orders-details__title">متن درخواست :</span>
                        <span className="orders-details__item">
                           {request.details.requestText || '-'}
                        </span>
                     </div>
                  </div>
               </div>
            </main>
         </div>
      </section>
   );
};

export default Request;